import ApplePayIcon from '@components/icons/apple-pay-icon';
import SpinnerIcon from '@components/icons/spinner-icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './apple-pay-button.module.scss';

export type ApplePayPaymentToken = ApplePayJS.ApplePayPaymentToken;

const ApplePayButton: React.FC<{
  readonly onClick: React.MouseEventHandler<HTMLButtonElement>;
  readonly loading?: boolean;
}> = ({ onClick, loading = false }) => {
  const { t } = useTranslation();

  return (
    <button type="button" onClick={onClick} className={styles.button}>
      {loading ? (
        <SpinnerIcon />
      ) : (
        <>
          <span>{t('payment.apple_pay_label')}</span>
          <ApplePayIcon aria-label="Apple Pay" />
        </>
      )}
    </button>
  );
};

export default ApplePayButton;
